<template>
  <v-footer
    app
    padless
  >
    <v-container fluid>
      <v-row
        wrap
        justify-center
      >
        <v-col
          cols="4"
          class="text-center"
        >
          <a
            href="https://www.spicetech.de/datenschutzerklaerung/"
            target="_blank"
          >Datenschutzerklärung</a>
        </v-col>
        <v-col
          cols="4"
          class="text-center"
        >
          <a
            href="https://www.spicetech.de/#Impressum"
            target="_blank"
          >Impressum</a>
        </v-col>
        <v-col
          cols="4"
          class="text-center"
        >
          <a
            href="mailto:quanticy@spicetech.de"
            target="_blank"
          >Support</a>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  data: () => ({})
};
</script>

<style scoped>
.container {
  padding-top: 0;
  padding-bottom: 0;

  border-top: 1px solid rgba(0, 0, 0, 0.2);
  background-color: rgba(0, 0, 0, 0.07);

  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 0 !important;
  -ms-flex: 0 1 auto !important;
  flex: 0 1 auto !important;
  min-height: 36px;
  -webkit-transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>
